<template>
  <div class="settheroseats">
    <v-btn
      class="mb-4"
      @click="reset"
    >
      <i class="mdi text-semi-large mdi-replay mr-2"></i>
      {{ $t('btn.reset_default') }}</v-btn
    >
    <div class="settheroseats_tables">
      <div
        v-for="(value, key, index) in tablesPlayers"
        :key="index"
        class="settheroseats_tables_table"
        :class="[`settheroseats_tables_table_${tableDirection}`]"
      >
        <div class="settheroseats_tables_table_name">
          {{ $t('common.num_players', { num: index + 2 }) }}
        </div>
        <PokerTableSkeleton
          :tableDirection="tableDirection"
          :players="value[playersKey]"
          :style="`
             font-size:9px;
              --cards-space: 0px;
              --table-hor-min-height: 100%;
              --clr-table-back: var(--clr-black-0-3);
              --clr-table-outline: var(--clr-black-3);
            `"
        >
          <template
            v-for="player in value[playersKey]"
            #[player.position]
            :key="player.position"
          >
            <div
              class="settheroseats_tables_table_circle"
              :class="{
                settheroseats_tables_table_circle_active: player.checked,
              }"
              @click="setHeroSeat(player, { value, key, index })"
            >
              <div class="mdi mdi-account-circle table-circle-icon"></div>
            </div>
          </template>
        </PokerTableSkeleton>
      </div>
    </div>
  </div>
</template>

<script>
import PokerTableSkeleton from '@/components/PokerTable/PokerTableSkeleton'

export default {
  name: 'SettingsHeroTableSeats',
  components: {
    PokerTableSkeleton,
  },
  props: {},
  data() {
    return {}
  },
  methods: {
    reset() {
      this.$store.dispatch('resetHeroTableSeats')
    },
    setHeroSeat(player, { value, key, index }) {
      if (player.checked) return
      const heroTableSeats = JSON.parse(JSON.stringify(this.heroTableSeats))
      heroTableSeats[key][this.playersKey === 'playersVr' ? 1 : 0] = player.idx
      console.log(player, { value, key, index }, heroTableSeats)
      this.$store.dispatch('setHeroTableSeats', { patchData: heroTableSeats })
    },
    getMockedPlayers({ numOfPlayers, heroSeatIdx }) {
      const res = [...new Array(numOfPlayers).keys()].map((i, idx) => ({
        idx,
        position: idx + 1,
        checked: idx === heroSeatIdx,
        // stack: 99,
        // position: `UTG${idx}`,
        // hand: 'AsAs',
        // chips_on_table: 99,
        // current_stack: 99,
        // next_chips_on_table: 99,
        // next_current_stack: 99,
        // is_dealer: true,
        // is_folded: false,
        // next_is_folded: false,
        // is_hero: false,
        // is_active: true,
      }))
      // console.log(res)
      return res
    },
  },
  computed: {
    tableDirection() {
      return this.mobile ? 'vertical' : 'horizontal'
    },
    playersKey() {
      return this.mobile ? 'playersVr' : 'players'
    },
    heroTableSeats() {
      return this.$store.getters.heroTableSeats
    },
    tablesPlayers() {
      const { heroTableSeats } = this
      const res = {}
      Object.keys(heroTableSeats).forEach(key => {
        const settingsVal = heroTableSeats[key]
        const numOfPlayers = Number(key.replace('_', ''))
        const heroSeatIdx = settingsVal[0]
        const heroSeatVrIdx = settingsVal[1]
        const players = this.getMockedPlayers({ numOfPlayers, heroSeatIdx })
        const playersVr = this.getMockedPlayers({ numOfPlayers, heroSeatIdx: heroSeatVrIdx })
        res[key] = {
          players,
          playersVr,
        }
      })
      return res
    },
    mobile() {
      return this.$store.getters.globals_mobile
    },
  },
}
</script>

<style lang="scss" scoped>
.settheroseats {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-self: flex-start;

  &_tables {
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: 1fr 1fr;
    &_table {
      display: flex;
      position: relative;
      width: 100%;
      height: 100%;
      min-height: 9rem;

      align-self: center;
      justify-self: center;
      &_vertical {
        min-height: 20rem;
        max-width: 14rem;
      }
      &_name {
        position: absolute;
        z-index: 4;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.875rem;
        font-weight: 500;
      }
      &_circle {
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
        width: 100%;
        --clr-back: transparent;
        --clr-border: var(--clr-black-3);
        --clr-active: var(--clr-trainer_player_hero);
        --icon-opacity: 0;
        background: var(--clr-black-1);
        border: solid 2px var(--clr-border);
        transition: 0.33s;
        &:hover {
          cursor: pointer;
          --clr-border: var(--clr-active);
          transition: 0.22s;
        }
        &_active {
          --clr-border: var(--clr-active);
          --icon-opacity: 1;
        }
        .table-circle-icon {
          opacity: var(--icon-opacity);
          transition: 0.22s;
          position: absolute;
          font-size: 3rem;
          color: var(--clr-border);
        }
      }
    }
  }
}
</style>
